export default function render({ root, component, is }) {
  // eslint-disable-next-line no-param-reassign
  component.$options.components[root.dataset.vueRoot] = is;
  component.$mount(root);
}
